import React, { useMemo } from "react";
import { Modal, DatePicker, Input, Alert } from "antd";
import PropTypes from "prop-types";
import moment from "moment";

/**
 * ExtendExpiryModal - Modal for extending wallet expiry date
 */
const ExtendExpiryModal = ({
  visible,
  record,
  date,
  note,
  loading,
  onDateChange,
  onNoteChange,
  onCancel,
  onSubmit,
}) => {
  if (!record) return null;

  // Get current expiry date as moment object
  const currentExpiryMoment = useMemo(() => {
    if (record.expire_date && record.expire_date.Valid) {
      return moment(record.expire_date.Time);
    }
    return null;
  }, [record.expire_date]);

  const currentExpiry = currentExpiryMoment
    ? currentExpiryMoment.format("DD/MM/YYYY")
    : "N/A";

  // Check if selected date is less than current expiry
  const isDateLessThanExpiry = useMemo(() => {
    if (date && currentExpiryMoment) {
      return date.isBefore(currentExpiryMoment, "day");
    }
    return false;
  }, [date, currentExpiryMoment]);

  // Disable dates: today and before
  const disabledDate = (current) => {
    return current && current <= moment().endOf("day");
  };

  return (
    <Modal
      title="Extend Expiry Date"
      visible={visible}
      onCancel={onCancel}
      onOk={onSubmit}
      confirmLoading={loading}
      okText="Extend"
      okButtonProps={{ disabled: !date || !note || note.trim() === "" }}
      maskClosable={false}
    >
      <div style={{ marginBottom: 16 }}>
        <label>
          Current Expiry: <strong>{currentExpiry}</strong>
        </label>
      </div>
      <div style={{ marginBottom: 16 }}>
        <label>New Expiry Date:</label>
        <DatePicker
          style={{ width: "100%", marginTop: 8 }}
          value={date}
          onChange={onDateChange}
          disabledDate={disabledDate}
          placeholder="Select a date after today"
        />
      </div>
      {isDateLessThanExpiry && (
        <Alert
          message="Warning"
          description="The selected date is earlier than the current expiry date. Are you sure you want to shorten the expiry period?"
          type="warning"
          showIcon
          style={{ marginBottom: 16 }}
        />
      )}
      <div>
        <label>Note: <span style={{ color: '#ff4d4f' }}>*</span></label>
        <Input.TextArea
          style={{ marginTop: 8 }}
          value={note}
          onChange={(e) => onNoteChange(e.target.value)}
          placeholder="Reason for extension..."
          rows={3}
        />
      </div>
    </Modal>
  );
};

ExtendExpiryModal.propTypes = {
  visible: PropTypes.bool.isRequired,
  record: PropTypes.object,
  date: PropTypes.object,
  note: PropTypes.string,
  loading: PropTypes.bool,
  onDateChange: PropTypes.func.isRequired,
  onNoteChange: PropTypes.func.isRequired,
  onCancel: PropTypes.func.isRequired,
  onSubmit: PropTypes.func.isRequired,
};

ExtendExpiryModal.defaultProps = {
  record: null,
  date: null,
  note: "",
  loading: false,
};

export default ExtendExpiryModal;



// WEBPACK FOOTER //
// ./src/containers/User/UserManagement/components/MemberCreditWallet/modals/ExtendExpiryModal.js